import React, { Component } from 'react';
import SquarePaymentForm, {
  CreditCardCVVInput,
  CreditCardExpirationDateInput,
  CreditCardNumberInput,
  CreditCardPostalCodeInput,
  CreditCardSubmitButton,
} from 'react-square-payment-form';
import { Form } from 'react-final-form';

import FormField from 'components/Form/FormField';
import { isNameValue } from 'utils/formValidators';
import '../../../assets/scss/modal.css';

class CreditCardForm extends Component {
  constructor() {
    super();
    this.state = {
      errors: [],
      formLoaded: false,
    };
  }

  saveNonce = (nonce, cardData, name) => {
    const { handleNext, setCardDetails } = this.props;
    const { billing_postal_code } = cardData;
    setCardDetails({ nonce, billing_name: name, zip: billing_postal_code });
    handleNext();
  };

  handleNonce = (errors, nonce, cardData, buyerVerificationToken, form) => {
    const nameField = form.getFieldState('name');
    const cardName = nameField.value;
    const nameError = isNameValue(nameField.value);
    if (errors || nameError) {
      return this.setState({ errors, nameError });
    }

    this.saveNonce(nonce, cardData, cardName);
  };

  render() {
    const { onCancel } = this.props;
    const { formLoaded, errors: errorMessages, nameError } = this.state;
    let formErrors = errorMessages || [];
    const errors = {};
    formErrors.map(error => (errors[error.field] = error));

    return (
      <Form
        onSubmit={() => {}}
        render={({ handleSubmit, form, submitting }) => (
          <form name="creditCardForm" onSubmit={handleSubmit}>
            <div className="row px-4">
              <FormField
                label="Name on Card"
                name="name"
                containerClassName="col-12 mt-2 sq-form-third"
                inputClassName="form-control px-4 py-3"
              />
              <div className="row error">
                {nameError && <span>{nameError}</span>}
              </div>
              <SquarePaymentForm
                applicationId={process.env.REACT_APP_SQUARE_APP_ID}
                sandbox={process.env.REACT_APP_SQUARE_ENV == "development"}
                cardNonceResponseReceived={(
                  errors,
                  nonce,
                  cardData,
                  buyerVerificationToken
                ) =>
                  this.handleNonce(
                    errors,
                    nonce,
                    cardData,
                    buyerVerificationToken,
                    form
                  )
                }
                paymentFormLoaded={() => this.setState({ formLoaded: true })}
              >
                <fieldset className="sq-fieldset">
                  <CreditCardNumberInput />
                  <div className="row error">
                    {errors.cardNumber && (
                      <span key={`sq-error-${errors.cardNumber.message}`}>
                        {errors.cardNumber.message}
                      </span>
                    )}
                  </div>
                  <div className="sq-form-third">
                    <CreditCardExpirationDateInput />
                    <div className="row error">
                      {errors.expirationDate && (
                        <span key={`sq-error-${errors.expirationDate.message}`}>
                          {errors.expirationDate.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="sq-form-third">
                    <CreditCardPostalCodeInput />
                    <div className="row error">
                      {errors.postalCode && (
                        <span key={`sq-error-${errors.postalCode.message}`}>
                          {errors.postalCode.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="sq-form-third">
                    <CreditCardCVVInput />
                    <div className="row error">
                      {errors.cvv && (
                        <span key={`sq-error-${errors.cvv.message}`}>
                          {errors.cvv.message}
                        </span>
                      )}
                    </div>
                  </div>
                </fieldset>
                <CreditCardSubmitButton>
                  Enter your billing address
                </CreditCardSubmitButton>
              </SquarePaymentForm>
            </div>
            <div className="mt-2">
              <button
                type="button"
                onClick={onCancel}
                disabled={submitting}
                className="w-100 border-0 bg-transparent text-center mt-3"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      />
    );
  }
}

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/components/Form/payment/creditCardForm.js